import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoutes from './routes/AdminRoutes';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Orders from './pages/Orders';
import Users from './pages/Users';
import Categories from './pages/Categories';
import Collections from './pages/Collections';
import Coupons from './pages/Coupons';
import Support from './pages/Support';
import ContactUs from './pages/ContactUs';
import FAQ from './pages/FAQ';
import Settings from './pages/Settings';
import Footer from './pages/Footer';
import Header from './pages/Header';
import LandingPage from './pages/LandingPage';
import Account from './pages/Account';

function App() {
  return (
    <Router>
      <AuthProvider>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/account" element={<Account />} />
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AdminRoutes />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products" element={<Products />} />
          <Route path="orders" element={<Orders />} />
          <Route path="users" element={<Users />} />
          <Route path="categories" element={<Categories />} />
          <Route path="collections" element={<Collections />} />
          <Route path="coupons" element={<Coupons />} />
          <Route path="support" element={<Support />} />
          <Route path="support/contact" element={<ContactUs />} />
          <Route path="support/faq" element={<FAQ />} />
          <Route path="settings" element={<Settings />} />
          <Route path="settings/landing" element={<LandingPage />} />
          <Route path="settings/footer" element={<Footer />} />
          <Route path="settings/header" element={<Header />} />
        </Route>
      </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
